export default "__VITE_ASSET__BS2h$AWH__"